import React from "react";
import { apiUrl } from "../../config/apiBase";

const INTERVAL_OBNOVY_MS = 15 * 60 * 1000;

const OBDOBIA = [
  { key: "den", label: "DNES" },
  { key: "tyzden", label: "7D" },
  { key: "mesiac", label: "1M" },
  { key: "rok", label: "1R" },
];

function formatujCenu(hodnota) {
  const cislo = Number(hodnota);
  if (!Number.isFinite(cislo)) return "-";

  return cislo.toLocaleString("sk-SK", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function formatujPercento(hodnota) {
  const cislo = Number(hodnota);
  if (!Number.isFinite(cislo)) return "0,00 %";

  const znamienko = cislo > 0 ? "+" : "";
  return `${znamienko}${cislo.toFixed(2).replace(".", ",")} %`;
}

export default function InvesticieTrhBanner() {
  const [data, setData] = React.useState(null);
  const [stav, setStav] = React.useState("loading");
  const [obdobie, setObdobie] = React.useState("den");

  React.useEffect(() => {
    let zrusene = false;

    const nacitaj = async () => {
      try {
        setStav("loading");

        const odpoved = await fetch(apiUrl(`/api/investicie/trh?obdobie=${obdobie}`), {
          credentials: "include",
        });

        if (!odpoved.ok) {
          throw new Error("Nepodarilo sa načítať trhové dáta");
        }

        const json = await odpoved.json();

        if (!zrusene) {
          setData(json);
          setStav("ok");
        }
      } catch {
        if (!zrusene) {
          setStav("error");
        }
      }
    };

    nacitaj();

    const interval = window.setInterval(nacitaj, INTERVAL_OBNOVY_MS);

    return () => {
      zrusene = true;
      window.clearInterval(interval);
    };
  }, [obdobie]);

  const items = Array.isArray(data?.items) ? data.items : [];

  if (stav === "error" || items.length === 0) {
    return null;
  }

  return (
    <div className="invest-trh-banner">
      <div className="invest-trh-banner__head">
        <div className="invest-trh-banner__switch" aria-label="Obdobie vývoja trhu">
          <span className="invest-trh-banner__label">TRHY</span>

          {OBDOBIA.map((item, index) => (
            <React.Fragment key={item.key}>
              <button
                type="button"
                className={`invest-trh-banner__period ${obdobie === item.key ? "is-active" : ""}`}
                onClick={() => setObdobie(item.key)}
              >
                {item.label}
              </button>

              {index < OBDOBIA.length - 1 ? (
                <span className="invest-trh-banner__sep">|</span>
              ) : null}
            </React.Fragment>
          ))}
        </div>

        <span className="invest-trh-banner__note">
          {data?.oneskorenieText || "↻ každých 15 min"}
        </span>
      </div>

      <div className="invest-trh-banner__items">
        {items.map((item) => {
          const jeRast = Number(item.zmenaPercent) >= 0;

          return (
            <div
              key={item.symbol}
              className={`invest-trh-banner__item ${jeRast ? "is-up" : "is-down"}`}
            >
              <span className="invest-trh-banner__symbol">
                <strong>{item.symbol}</strong>
                <span>{item.nazov}</span>
              </span>

              <span className="invest-trh-banner__value">
                <strong>{item.dostupne ? formatujCenu(item.cena) : "—"}</strong>
                <span>{item.dostupne ? formatujPercento(item.zmenaPercent) : "nedostupné"}</span>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}